<template>
    <div class="container">
        <div class="uniform-modal-body">
            <!-- <b-row class="justify-content-center mb-3">
                <h5 class="password-policy-title">{{ labels.title }}</h5> 
            </b-row> -->
            <b-row class="mb-2 align-items-center">
                <b-col cols="1"></b-col>
                <b-col cols="5" class="text-left">
                    <label class="password-policy-item">{{ labels.constante }}1</label> 
                </b-col>
                <b-col cols="6" class="text-left">
                    <b-form-input
                        v-model="constanteUno"
                        type="number"
                        class="reset-input"
                        :placeholder="labels.constante + '1'"
                    ></b-form-input>
                </b-col>
            </b-row>

            <b-row class="mb-2 align-items-center">
                <b-col cols="1"></b-col>
                <b-col cols="5" class="text-left">
                    <label class="password-policy-item">{{ labels.constante }}2</label> 
                </b-col>
                <b-col cols="6" class="text-left">
                    <b-form-input
                        v-model="constanteDos"
                        type="number"
                        class="reset-input"
                        :placeholder="labels.constante + '2'"
                    ></b-form-input>
                </b-col>
            </b-row>

            <b-row class="mb-2 align-items-center">
                <b-col cols="1"></b-col>
                <b-col cols="5" class="text-left">
                    <label class="password-policy-item">{{ labels.constante }}3</label> 
                </b-col>
                <b-col cols="6" class="text-left">
                    <b-form-input
                        v-model="constanteTres"
                        type="number"
                        class="reset-input"
                        :placeholder="labels.constante + '3'"
                    ></b-form-input>
                </b-col>
            </b-row>

            <b-row class="mb-2 align-items-center">
                <b-col cols="1"></b-col>
                <b-col cols="5" class="text-left">
                    <label class="password-policy-item">{{ labels.constante }}4</label> 
                </b-col>
                <b-col cols="6" class="text-left">
                    <b-form-input
                        v-model="constanteCuatro"
                        type="number"
                        class="reset-input"
                        :placeholder="labels.constante + '4'"
                    ></b-form-input>
                </b-col>
            </b-row>

            <b-row class="mb-3 align-items-center">
                <b-col cols="1"></b-col>
                <b-col cols="5" class="text-left">
                    <label class="password-policy-item">Score</label>
                </b-col>
                <b-col cols="6" class="text-left">
                    <b-form-input
                        v-model="score"
                        type="number"
                        class="reset-input"
                        placeholder="Score"
                    ></b-form-input>
                </b-col>
            </b-row>

            <!-- <div class="reset-dialog-actions d-flex justify-content-end mt-3 uniform-actions-wrap">
                <b-button
                    class="reset-btn-primary"
                    @click="guardarConstante"
                >
                    {{ labels.save }}
                </b-button>
            </div> -->
        </div>
    </div>
</template>

<script>
import Constante from '../../../services/Constante'; 

export default {
    name: 'Constantes',
    props: {
        infoVigencia: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            constanteUno: '',
            constanteDos: '',
            constanteTres: '',
            constanteCuatro: '',
            score: '',
            infoConstantes: []
        }
    },
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") { 
                return {
                    title: 'Constantes',
                    save: 'Guardar',
                    close: 'Cerrar',
                    vigencia: 'Vigencia',
                    constante: 'X',
                    edit: 'Editar'
                }
            } else {
                return {
                    title: 'Constants',
                    save: 'Save',
                    close: 'Close',
                    vigencia: 'Validity',
                    constante: 'X',
                    edit: 'Edit'
                }
            }
        }
    },
    methods: {
        guardarConstante() {
            if (!this.constanteUno || 
                !this.constanteDos || 
                !this.constanteTres || 
                !this.constanteCuatro || 
                !this.score
            ) {
                this.$toast.error('Campo(s) pendiente(s) por diligenciar');
                return;
            }

            let info = [
                {
                    'vigencia': this.infoVigencia, 
                    'constante': this.constanteUno, 
                    'idUser': this.$store.state.userId 
                },
                {
                    'vigencia': this.infoVigencia, 
                    'constante': this.constanteDos, 
                    'idUser': this.$store.state.userId 
                },
                {
                    'vigencia': this.infoVigencia, 
                    'constante': this.constanteTres, 
                    'idUser': this.$store.state.userId 
                },
                {
                    'vigencia': this.infoVigencia, 
                    'constante': this.constanteCuatro, 
                    'idUser': this.$store.state.userId 
                },
                {
                    'vigencia': this.infoVigencia, 
                    'score': this.score, 
                    'idUser': this.$store.state.userId 
                }
            ]
            
            Constante.createConstante(info) 
            .then((res) => { 
                if (res.status == 201) { 
                    this.$toast.success(res.data.message) 
                    this.$emit('constante-creada');
                    this.cleanInputs();
                }
            })
            .catch((err) => console.log(err)) 
        },
        cleanInputs() {
            this.constanteUno = '';
            this.constanteDos = '';
            this.constanteTres = '';
            this.constanteCuatro = '';
            this.score = '';
        }
    },
    mounted() {
        Constante.getConstanteByVigencia(this.infoVigencia) 
            .then((res) => { 
                if (res.data.constanteByVigencia && res.data.constanteByVigencia.length > 0) {
                    this.infoConstantes = res.data.constanteByVigencia;
                    // Cargar datos existentes si los hay
                    this.constanteUno = this.infoConstantes[0]?.constante_1 || '';
                    this.constanteDos = this.infoConstantes[0]?.constante_2 || '';
                    this.constanteTres = this.infoConstantes[0]?.constante_3 || '';
                    this.constanteCuatro = this.infoConstantes[0]?.constante_4 || '';
                    this.score = this.infoConstantes[0]?.score || '';
                }
            })
            .catch((err) => console.log(err)) 
    }
}
</script>

<style>
/* Estilos consistentes con el componente Crear */
.reset-input {
    width: 100%;
    padding: 0.5rem 0.75rem;
    border: 1px solid #ced4da;
    border-radius: 6px;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.reset-input:focus {
    border-color: #80bdff;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.password-policy-box {
    background-color: #f8f9fa;
    border-radius: 8px;
    padding: 1rem;
    margin-bottom: 1.5rem;
}

.password-policy-title {
    font-weight: 600;
    color: #2c3e50;
    font-size: 1rem;
}

.password-policy-item {
    font-weight: 500;
    color: #495057;
    font-size: 0.95rem;
}

.uniform-modal-body {
    padding: 0.5rem 0;
}

.reset-dialog-actions {
    gap: 10px;
}

.reset-btn-primary {
    background-color: #007bff;
    border: 1px solid #007bff;
    color: white;
    padding: 0.5rem 1.5rem;
    border-radius: 6px;
    font-weight: 500;
    transition: all 0.3s ease;
}

.reset-btn-primary:hover {
    background-color: #0069d9;
    border-color: #0062cc;
    color: white;
}

.reset-btn-secondary {
    background-color: #6c757d;
    border: 1px solid #6c757d;
    color: white;
    padding: 0.5rem 1.5rem;
    border-radius: 6px;
    font-weight: 500;
    transition: all 0.3s ease;
}

.reset-btn-secondary:hover {
    background-color: #5a6268;
    border-color: #545b62;
    color: white;
}

@media (max-width: 768px) {
    .reset-dialog-actions {
        flex-direction: column;
    }
    
    .reset-dialog-actions .b-button {
        width: 100%;
        margin: 0.25rem 0 !important;
    }
}
</style>